import { render, staticRenderFns } from "./FactionPanel.vue?vue&type=template&id=544532d1&"
import script from "./FactionPanel.vue?vue&type=script&lang=js&"
export * from "./FactionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports